
export const endOfMonthSpendHistory = (monthlyExpenses, monthlyChargeExpenses, monthlyLoanAmts, spendHistory,
        nbrMonthsPerTurn) => {
    
    if (spendHistory.current10YearMonths >= 120){
        spendHistory.previous10YearSpendAmt = +spendHistory.current10YearSpendAmt;
        spendHistory.previous10YearMonths = +spendHistory.current10YearMonths;
        spendHistory.current10YearSpendAmt = 0;
        spendHistory.current10YearMonths = 0;
    }
    //  this field is named currentMonthSpendAmt, but it is actually 'currentTurnSpendAmt' (if turn is 3 months
    //  long, then this field contains amounts spent during the 3 month turn)
    //  the "monthly" amounts have already been multiplied by nbrMonthsPerTurn before entering this process
    //  except the "currentMonthSpendAmt"     
    let invalidArr = [];
    if (isNaN(+monthlyExpenses)){
        invalidArr.push({fieldName: "monthlyExpenses", fieldValue: monthlyExpenses});
        monthlyExpenses = 0;
    }
    if (isNaN(+monthlyChargeExpenses)){
        invalidArr.push({fieldName: "monhthlyChargeExpenses", fieldValue: monthlyChargeExpenses});
        monthlyChargeExpenses = 0;
    }
    if (isNaN(+monthlyLoanAmts)){
        invalidArr.push({fieldName: "monthlyLoanAmts", fieldValue: monthlyLoanAmts});
        monthlyLoanAmts = 0;
    }
    if (isNaN(nbrMonthsPerTurn)){
        invalidArr.push({fieldName: "nbrMonthsPerTurn", fieldValue: nbrMonthsPerTurn});
        nbrMonthsPerTurn = 1;
    }
    spendHistory.currentMonthSpendAmt = ((+spendHistory.currentMonthSpendAmt * nbrMonthsPerTurn) + 
            +monthlyExpenses + +monthlyChargeExpenses + +monthlyLoanAmts).toFixed(2);
   
    spendHistory.current10YearSpendAmt = +spendHistory.current10YearSpendAmt + 
        +spendHistory.currentMonthSpendAmt;
    
    spendHistory.current10YearSpendAmt = (+spendHistory.current10YearSpendAmt).toFixed(2);
    spendHistory.current10YearMonths += nbrMonthsPerTurn;
    spendHistory.currentMonthSpendAmt = 0;
    //  keeping 6 turns of spending amounts for use when number months per turn is greater than 0
    if (spendHistory.turnCashAmtArr){
        if (spendHistory.turnCashAmtArr.length > 6){
            const numberToRemove = spendHistory.turnCashAmtArr.length - 6;
            spendHistory.turnCashAmtArr.splice(0,numberToRemove);
        }
        spendHistory.turnCashAmtArr.push("0");
    }

    if (spendHistory.turnCreditAmtArr){
        if (spendHistory.turnCreditAmtArr.length > 6){
            const numberToRemove = spendHistory.turnCreditAmtArr.length - 6;
            spendHistory.turnCreditAmtArr.splice(0,numberToRemove);
        }
        spendHistory.turnCreditAmtArr.push("0");
    }
    const returnObj={spendHistory: spendHistory, invalidArr: invalidArr}
    return returnObj;
   
}
export default endOfMonthSpendHistory;
